import Repository from "./masterRepository";

const getLog = "getLogs"
const addLog = "addLogs"
const editLog = "editLogs"
const deleteLog = "deleteLogs"

const getLogTable = "getLogTable"
const addLogTable = "addLogTable"
const editLogTable = "editLogTable"
const deleteLogTable = "deleteLogTable"

export default {
    getLogsDetails(payload) {
        return Repository.post(transformRoute(getLog), payload);
    },
    addLogsDetails(payload) {
        return Repository.post(transformRoute(addLog), payload);
    },
    editLogsDetails(payload) {
        return Repository.post(transformRoute(editLog), payload);
    },
    deleteLogsDetails(payload) {
        return Repository.post(transformRoute(deleteLog), payload);
    },

    getLogsTable(payload) {
        return Repository.post(transformRoute(getLogTable), payload);
    },
    addLogsTable(payload) {
        return Repository.post(transformRoute(addLogTable), payload);
    },
    editLogsTable(payload) {
        return Repository.post(transformRoute(editLogTable), payload);
    },
    deleteLogsTable(payload) {
        return Repository.post(transformRoute(deleteLogTable), payload);
    },

    
}
const transformRoute = (route) => {
  return `/logs/${route}`;
};